import { Component, JSX, Suspense } from 'solid-js';

interface LandingLayoutProps {
  children?: JSX.Element;
}

export const LandingLayout: Component<LandingLayoutProps> = (props) => {
  return (
    <>
      <div class="relative h-full grid grid-rows-[1fr]">
        <div class="overflow-y-auto">
          <main class="h-full w-full flex flex-col justify-center items-center relative bg-radial to-background/30 from-primary-dark/30">
            <Suspense>{props.children}</Suspense>
          </main>
        </div>
      </div>
    </>
  );
};
